<template>
    <div class="parent__password-protected">
        <div class="post__password-protected">
            <form @submit.prevent="handleFormSubmit" class="post__password-form" method="POST">
                <div class="post__password-description"><p>This content is password protected. To view it please enter your password below:</p></div>
                <input
                    v-model="password"
                    type="password"
                    name="post_password"
                    id="password"
                    spellcheck="false"
                    size="20"
                />
                <input type="submit" name="submit" value="Submit" />
            </form>
            <div v-if="errorMessage" class="error">{{ errorMessage }}</div>
        </div>
    </div>
</template>
<style lang="scss">
.parent__password-protected{
    padding: 30px 0
}
.post__password-protected {
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background-color: #f9f9f9;
    max-width: 400px;
    margin: 0px auto;

    .post__password-description {
        margin-bottom: 15px;
        font-size: 14px;
        color: #282828;
    }

    input[type="password"] {
        width: 100%;
        padding: 10px;
        margin-bottom: 10px;
        border: 1px solid #ccc;
        border-radius: 4px;
        font-size: 16px;
    }

    input[type="submit"] {
        background-color: #c60c46;
        color: white;
        border: none;
        padding: 10px 15px;
        border-radius: 4px;
        cursor: pointer;
        font-size: 16px;
        &:hover {
            background-color: #c60c46;
        }
        &:focus {
            background-color: #c60c46;
        }
    }

    .error {
        color: #c60c46;
        margin-top: 10px;
        font-size: 14px;
    }
}
</style>
<script lang="ts" setup>
import { ref } from 'vue';
const { $ajax } = useNuxtApp();
const props = defineProps(["data"]);
const productId = computed(() => props.data);
const emit = defineEmits<{
    (e: 'handlePasswordProtect', isSuccess: boolean): void;
}>();
const password = ref('');
const errorMessage = ref('');

interface IPasswordProtectedResponse{
    success: boolean;
    message: string;
}
const handleFormSubmit = async () => {
    if (!password.value) {
        errorMessage.value = 'Password is required.';
        return;
    }
    try {
        const response = await $ajax.post<IPasswordProtectedResponse>('/wp-admin/admin-ajax.php', {
            action: 'alt_unlock_content',
            post_password: password.value,
            id: productId.value
        }, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
        if (response && response.success){
            emit('handlePasswordProtect', true);
            errorMessage.value = '';
        }else{
            errorMessage.value = response.message
        }
    } catch (error) {
        errorMessage.value = 'An error occurred. Please try again later.';
        console.error("Password Protected Form Error", error);
    }
};
</script>